import { render, staticRenderFns } from "./GroupNewsPage.vue?vue&type=template&id=796cc7d1&scoped=true&"
import script from "./GroupNewsPage.vue?vue&type=script&lang=js&"
export * from "./GroupNewsPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupNewsPage.vue?vue&type=style&index=0&id=796cc7d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796cc7d1",
  null
  
)

export default component.exports